import { Injectable } from '@angular/core';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { CmsContactUsPage } from '@support/util-models';
import { combineLatest, Observable } from 'rxjs';

export interface ViewModel {
  cmsData: CmsContactUsPage;
}

@Injectable()
export class ContactUsComponentService {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
  });

  constructor(private readonly cmsContainer: CmsContainer<CmsContactUsPage>) {}
}
